import Logo from "@/components/ui/Logo";
import content from "@/content/social.json";

interface Data {
  discord: string;
  x: string;
}

const data: Data = content;

import { SiDiscord, SiX } from "@icons-pack/react-simple-icons";

const Footer = () => {
  return (
    <footer className="border-border border-t py-10">
      <div className="mx-auto flex max-w-7xl flex-col items-center justify-between gap-4 px-4 sm:px-6 lg:flex-row lg:px-8">
        <Logo />
        <p className="text-muted-foreground text-center text-sm">
          © {new Date().getFullYear()} Wanderson Felipe. Todos os direitos
          reservados.
        </p>
        <div className="flex items-center gap-3">
          <a href={data.discord} target="_blank" rel="noopener">
            <SiDiscord size={22} cursor="pointer" />
          </a>
          <a href={data.x} target="_blank" rel="noopener">
            <SiX size={18} cursor="pointer" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
